import { cloneDeep, isEmpty, set } from 'lodash';
import { Template } from 'components/ui/composed/template/TemplateContext';
import { TransformData } from 'views/declarations/declaration-tabs/declaration-form/DeclarationFormTab';
import { ItemPathMappings } from 'views/declarations/declaration-tabs/declaration-form/utils/listItemsIntoForm';

export const buildIcs2TemplateFormErrors = (errors: any, itemPaths: ItemPathMappings | undefined) => {
    const next = cloneDeep(errors?.master?.defaults ?? {});

    const masterItemPath = itemPaths?.find((mapping) => !(mapping as any).parentPath);
    const houseItemPath = itemPaths?.find((mapping) => (mapping as any).parentPath) as
        | { path: string; parentPath: string }
        | undefined;

    if (masterItemPath && !isEmpty(errors?.product?.defaults)) {
        set(next, masterItemPath.path, [errors.product.defaults]);
    }

    if (houseItemPath) {
        const houseConsignment = cloneDeep(errors?.houseConsignment?.defaults ?? {});

        if (!isEmpty(errors?.houseGoodsItem?.defaults)) {
            set(houseConsignment, houseItemPath.path, [errors.houseGoodsItem.defaults]);
        }

        if (!isEmpty(houseConsignment)) {
            set(next, houseItemPath.parentPath, [houseConsignment]);
        }
    }

    return next;
};

export const transformTemplateData = (
    template: Template | undefined,
    transform: TransformData | undefined | null,
    target: 'forClient' | 'forServer'
) => {
    const templateCopy = cloneDeep(template);
    if (transform && templateCopy) {
        // Only assign when a transform actually exists for the level. Calling through an
        // absent one yields undefined, which would blank the level's defaults.
        if (transform.declaration?.[target]) {
            templateCopy.master.defaults = transform.declaration[target]!(templateCopy?.master?.defaults, true);
        }
        if (transform.product?.[target]) {
            templateCopy.product.defaults = transform.product[target]!(
                templateCopy?.product?.defaults?.governmentAgencyGoodsItem ?? templateCopy?.product?.defaults,
                true
            );
        }
        // Only present for declaration types with a house level (ICS2 ENS). Left untouched
        // when the map defines no transform for it.
        if (templateCopy.houseConsignment && transform?.houseConsignment?.[target]) {
            templateCopy.houseConsignment.defaults = transform.houseConsignment[target]!(
                templateCopy.houseConsignment.defaults,
                true
            );
        }
        // Likewise for the house-level goods item, which only message types whose topology allows
        // house goods items carry.
        if (templateCopy.houseGoodsItem && transform?.houseGoodsItem?.[target]) {
            templateCopy.houseGoodsItem.defaults = transform.houseGoodsItem[target]!(
                templateCopy.houseGoodsItem.defaults,
                true
            );
        }
    }
    return templateCopy;
};
